import { createSelector } from 'reselect'

import { selectJBPSettings } from './selectJBPSettings'

export const selectKiBusinessPriorities = createSelector(
  [selectJBPSettings],
  ({ kiBusinessPriorities }) => kiBusinessPriorities
)
